import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface PrefsState {
  /** Path to land on after login + when `/` is hit directly. Empty = default `/dashboard`. */
  defaultLandingPath: string;
  setDefaultLandingPath: (path: string) => void;
}

/**
 * Per-user preferences, persisted to localStorage only (no server round-trip).
 * Each user on this browser keeps their own snapshot independent of others —
 * useful on shared lab machines where different staff log in to the same OS user.
 */
export const usePrefsStore = create<PrefsState>()(
  persist(
    (set) => ({
      defaultLandingPath: '',
      setDefaultLandingPath: (defaultLandingPath) => set({ defaultLandingPath }),
    }),
    { name: 'school.prefs' },
  ),
);

export function getDefaultLandingPath(): string {
  const path = usePrefsStore.getState().defaultLandingPath;
  return path && path.startsWith('/') ? path : '/dashboard';
}
